webpackJsonp([17],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoxSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.shadow, this.props.shadow), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.hidden, this.props.hidden), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          shadow = _props.shadow,
          restProps = _objectWithoutProperties(_props, ['children', 'shadow']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        this.props.children
      );
    }
  }]);

  return Box;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Box.defaultProps = {
  className: '',
  shadow: false,
  hidden: false
};


var BoxSection = function BoxSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      disabledContent = _ref.disabledContent,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'disabled', 'disabledContent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.section, className) }),
    children,
    disabled && _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.disabledOverlay
    }, void 0, disabledContent)
  );
};

BoxSection.defaultProps = {
  className: '',
  disabled: false,
  disabledContent: null
};

/* harmony default export */ __webpack_exports__["b"] = (Box);


/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Ob7a","shadow":"_3NCC3","hidden":"_170VA","section":"UNjnV","disabledOverlay":"_2jdoD"};

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Distribute = function (_Component) {
  _inherits(Distribute, _Component);

  function Distribute() {
    _classCallCheck(this, Distribute);

    return _possibleConstructorReturn(this, (Distribute.__proto__ || Object.getPrototypeOf(Distribute)).apply(this, arguments));
  }

  _createClass(Distribute, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.direction], __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.size], _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.equalHeight, this.props.equalHeight), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          direction = _props.direction,
          size = _props.size,
          equalHeight = _props.equalHeight,
          restProps = _objectWithoutProperties(_props, ['children', 'direction', 'size', 'equalHeight']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
          return child ? _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.child
          }, void 0, child) : null;
        })
      );
    }
  }]);

  return Distribute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Distribute.defaultProps = {
  className: '',
  direction: 'row',
  size: 'medium',
  equalHeight: false
};


/* harmony default export */ __webpack_exports__["a"] = (Distribute);

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3G5Nu","row":"YFKO0","small":"_1Vnfv","medium":"_2HJ1j","large":"KtknO","child":"_3gHnX","equalHeight":"QItAK"};

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tryApiCall;
var _marked = /*#__PURE__*/regeneratorRuntime.mark(tryApiCall);

function tryApiCall(name, defaultValue, apiCall) {
  var _ref, data;

  return regeneratorRuntime.wrap(function tryApiCall$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return apiCall;

        case 3:
          _ref = _context.sent;
          data = _ref.data;
          return _context.abrupt("return", data);

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);

          console.info("Failed to get " + name + ", ignoring", _context.t0);
          return _context.abrupt("return", defaultValue);

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 8]]);
}

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(528);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({
  initialized: false,
  topics: [],
  schools: []
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */], {
  SET: function SET(state, _ref) {
    var payload = _ref.payload;
    return state.merge(payload);
  }
}), initialState));

/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(528);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var reduxActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */], {
  SET: undefined,
  INITIALIZE: undefined
}));

/* harmony default export */ __webpack_exports__["a"] = (reduxActions[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */]]);

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_sagas__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(109);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onInitialize),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);






function onInitialize() {
  var _ref, _ref2, rspTopics, rspSchools;

  return regeneratorRuntime.wrap(function onInitialize$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__utilities_sagas__["a" /* tryApiCall */], 'topics', [], Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].topic, 'list'])), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__utilities_sagas__["a" /* tryApiCall */], 'schools', [], Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])([__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].school, 'list']))]);

        case 3:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 2);
          rspTopics = _ref2[0];
          rspSchools = _ref2[1];
          _context.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */].set({
            initialized: true,
            topics: rspTopics,
            schools: rspSchools
          }));

        case 9:
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](0);

          console.error('Failed to get topics & schools', _context.t0);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 11]]);
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */].initialize.toString(), onInitialize)]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ 1608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_selectors__ = __webpack_require__(147);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var stateSelector = function stateSelector(state) {
  return state.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */]) || __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* initialState */];
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(stateSelector, __WEBPACK_IMPORTED_MODULE_1_utilities_routes__["b" /* locationSelector */], __WEBPACK_IMPORTED_MODULE_4__App_selectors__["a" /* accountSelector */], function (state, location, account) {
  return _extends({
    location: location,
    account: account
  }, state.toJS());
}));

/***/ }),

/***/ 1609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"vmcCi","button":"_1vEO9","link":"_1rwHw","boxes":"_2JteP"};

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_reducers__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_sagas__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_layouts_Page__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sagas__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layouts_Distribute__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layouts_Box__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Spinner__ = __webpack_require__(519);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n                      ###Aktiviteter\n\n                      Aktiviteter som erbjuds\n                    '], ['\n                      ###Aktiviteter\n\n                      Aktiviteter som erbjuds\n                    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n                      ###Skolor\n\n                      P\xE5 f\xF6ljande skolor erbjuds aktiviteter\n                      '], ['\n                      ###Skolor\n\n                      P\xE5 f\xF6ljande skolor erbjuds aktiviteter\n                      ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_19__components_Spinner__["a" /* default */], {
  width: '45',
  height: '45',
  center: true
});

var ListTopicsAndSchools = function (_Component) {
  _inherits(ListTopicsAndSchools, _Component);

  function ListTopicsAndSchools() {
    _classCallCheck(this, ListTopicsAndSchools);

    return _possibleConstructorReturn(this, (ListTopicsAndSchools.__proto__ || Object.getPrototypeOf(ListTopicsAndSchools)).apply(this, arguments));
  }

  _createClass(ListTopicsAndSchools, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_3_state_reducers__["a" /* addReducer */])(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_4_state_sagas__["a" /* addSaga */])(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_11__sagas__["a" /* default */]);
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* default */].initialize());
    }

    // Properties and state seem to me same with redux
    // See state vars in reducer.js

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      Object(__WEBPACK_IMPORTED_MODULE_3_state_reducers__["c" /* removeReducer */])(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* NAME */]);
      Object(__WEBPACK_IMPORTED_MODULE_4_state_sagas__["b" /* removeSaga */])(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* NAME */]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          topics = _props.topics,
          schools = _props.schools,
          initialized = _props.initialized;


      if (!initialized) {
        return _ref;
      }

      topics.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      schools.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      var topicLinks = topics.map(function (topic) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_7_components_Link__["a" /* default */], {
          label: topic.name,
          className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.link,
          href: Object(__WEBPACK_IMPORTED_MODULE_18__utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_17__FindActivity_constants__["a" /* NAME */], { query: { tag: topic.name } })
        }, topic.id);
      });
      var schoolLinks = schools.map(function (school) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_7_components_Link__["a" /* default */], {
          label: school.name,
          className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.link,
          href: Object(__WEBPACK_IMPORTED_MODULE_18__utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_17__FindActivity_constants__["a" /* NAME */], { query: { tag: school.name } })
        }, school.id);
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_5_layouts_Page__["a" /* default */]
      // {...this.props.meta.toJS()}
      , {
        className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.root,
        title: 'Aktiviteter och skolor'
      }, 'page', _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.boxes
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_layouts_Container__["a" /* default */], {
        size: 'medium'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__layouts_Distribute__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_djedi_react__["Node"], {
        uri: 'activities_and_schools/activities_title.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_1_djedi_react__["md"])(_templateObject))), _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["a" /* BoxSection */], {}, void 0, topicLinks)), _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_djedi_react__["Node"], {
        uri: 'activities_and_schools/schools_title.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_1_djedi_react__["md"])(_templateObject2))), _jsx(__WEBPACK_IMPORTED_MODULE_16__layouts_Box__["a" /* BoxSection */], {}, void 0, schoolLinks))))));
    }
  }]);

  return ListTopicsAndSchools;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_12__selectors__["a" /* default */])(ListTopicsAndSchools));

/***/ })

});


// WEBPACK FOOTER //
// views/ActivitiesAndSchools-index.501defe37f7663b4a82d.js